module.exports = __webpack_public_path__ + "assets/img/00143.164e9b71.png";